import { useAppStore } from "@/stores/app";
import { InternalAxiosRequestConfig } from "axios";

export default function version(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  config.headers["X-Client-Version"] = useAppStore().version;
  config.headers["X-Client-Platform"] = "web";
  config.headers["X-Client-Commit"] = useAppStore().commit;

  return config;
}
